import { LISTAR_TIPOPAGOS } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LISTAR_TIPOPAGOS:
      return {
        ...state,
        tipoPagos: action.payload,
      };

    default:
      return state;
  }
};
